import moment from 'moment-timezone';
import { PersonExamService } from '../../core/http/service/PersonExam';
import BaseResponse from '../../models/core/BaseResponse';
import ExameCard from '../../models/core/exams/ExameCard';

const sendToAnalytics = (action: string = '', error: any = null) => {
    console.error(action, error);
}

export const FETCH_EXAMS = "FETCH_EXAMS";

export const fetchExams = (idUser: string) => {
    return async (dispatch: any) => {
        const service: PersonExamService = new PersonExamService();

        try {

            const response: any = await service.getExamsCard(idUser);
            const baseResponse: BaseResponse<any> = new BaseResponse().fromJSON(response.data)
            const exames: ExameCard[] = []

            baseResponse?.data?.forEach((data: any) => {
                exames.push(new ExameCard().fromJSON(data))
            })
            
            dispatch({
                type: FETCH_EXAMS,
                exames: exames
            })
        } catch (error: any) {
            sendToAnalytics(error);
            throw error;
        }
    }
};

export const registerExamResult = (results: any, pessoaId: string) => {
    return async (dispatch: any) => {
        const service: PersonExamService = new PersonExamService();
        try {
            for (const result of results) {
                const object = {
                    exameId: result.exameId,
                    pessoaId: pessoaId,
                    dataColeta: result.dataColeta,
                    dataResultado: moment().format('YYYY-MM-DD'),
                    valor: result.valor !== '' ? result.valor : result.texto,
                    unidade: result.unidade,
                    formato: result.formato
                }

                await service.registerExamResult(object)
            }
        } catch (error: any) {
            sendToAnalytics(error);
            throw error;
        }
    }
}